// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1tzdX","list":"styles_list__tD_Zw"};